import { Permission } from '@common/index';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/methodological-elements',
    name: 'methodologicalElementList',
    component: () => import('../pages/MethodologicalElementListPage.vue'),
    meta: {
      requiresAuth: true,
      permission: Permission.MENU_ADMINISTRATION
    }
  }
];

export default routes;
